import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "@/store/store";

export interface SmartLinkState {
  active: boolean;
  snapshotApplied: string[] | null;
  linkSegments: string[] | null;
  enteredPath: string | null;
}

const initialState: SmartLinkState = { active: false, snapshotApplied: null, linkSegments: null, enteredPath: null };

const smartLinkSlice = createSlice({
  name: "smartLink",
  initialState,
  reducers: {
    enterSmartLink: (
      state,
      action: PayloadAction<{ snapshotApplied: string[]; linkSegments: string[]; enteredPath: string }>,
    ) => {
      if (!state.active) {
        state.snapshotApplied = action.payload.snapshotApplied;
        state.enteredPath = action.payload.enteredPath;
      }
      state.active = true;
      state.linkSegments = action.payload.linkSegments;
    },
    setLinkSegments: (state, action: PayloadAction<string[]>) => {
      state.linkSegments = action.payload;
    },
    exitSmartLink: () => initialState,
  },
});

export const { enterSmartLink, setLinkSegments, exitSmartLink } = smartLinkSlice.actions;
export const selectSmartLink = (state: RootState): SmartLinkState => state.smartLink;
export default smartLinkSlice.reducer;
